const useColumnsTwo = () => {
  const columnsInside = [
    { Header: "รหัสสินค้า", accessor: "product_code" },
    { Header: "ชื่อสินค้า", accessor: "product_name" },
  ];

  return columnsInside;
};

export default useColumnsTwo;
